import React, {Component} from 'react'
import {connect} from 'react-redux'
import FJCommonModal from '../../../common/component/modal/FJCommonModal';
import FJRecordFromModal from '../view/FJRecordFromModal';
import {FJModalAction, FJRecordingAction} from "../../../redux/action/FJRoot.action";
import FJLocalStore from "../../../store/FJLocalStore";

class FJRecordFromModalContainer extends Component {

  constructor(props) {
    super(props);
    this._recordFrom = React.createRef();
  }

  /**
   * @description 点击退出
   * @private
   */
  _onCancel = () => {
    this.props.onCancel();
    this._recordFrom.current.initData();
  };

  render() {
    let {
      visible,
      onCancel,
      webCamClick,
      screenClick
    } = this.props;

    return (
      <FJCommonModal visible={visible}
                     hasInnerCloseBtn
                     hasInnerTitle
                     title={FJLocalStore._('record-from')}
                     onCancel={this._onCancel}
                     width='540px'

      >
        <FJRecordFromModal ref={this._recordFrom}
                           visible={visible}
                           onCancel={onCancel}
                           screenClick={screenClick}
                           webCamClick={webCamClick}
        />
      </FJCommonModal>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    visible: state.modal.isShowRecordFromModal,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    onCancel: function () {
      dispatch(FJModalAction.setIsShowReRecordFromModalAction(false));
    },
    screenClick: function () {
      dispatch(FJModalAction.setIsShowReRecordFromModalAction(false));
      dispatch(FJRecordingAction.startRecordScreenAction());
    },
    webCamClick: function () {
      dispatch(FJModalAction.setIsShowReRecordFromModalAction(false));
      dispatch(FJRecordingAction.startRecordWebCamAction());
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJRecordFromModalContainer);
